export default {
  title: 'Kehittäjät',
  subtitle: 'API-avaimet, webhookit ja toimitushistoria Partner API -integraatiotasi varten.',
  no_account: 'Ei vielä Partner API -tiliä – ota yhteyttä Foodamigosiin saadaksesi sellaisen.',
  no_account_manage: 'Ei vielä Partner API -tiliä – luo yksi avainten julkaisua varten.',
  buttons: {
    new_account: 'Uusi tili',
    edit_account: 'Muokkaa tiliä',
    docs: 'API-dokumentaatio',
  },
  tabs: {
    api_keys: 'API-avaimet',
    webhooks: 'Webhookit',
    deliveries: 'Toimitukset',
  },
  toasts: {
    load_error: 'Partner API -tilejäsi ei voitu ladata.',
  },
};
